<script setup>
import OnboardingFeatureCard from './OnboardingFeatureCard.vue';
import ChannelFlowScene from './onboarding/ChannelFlowScene.vue';
import TeamScene from './onboarding/TeamScene.vue';
import CannedResponseScene from './onboarding/CannedResponseScene.vue';
import LabelsScene from './onboarding/LabelsScene.vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';

const getters = useStoreGetters();
const { t } = useI18n();
const globalConfig = computed(() => getters['globalConfig/get'].value);
const currentUser = computed(() => getters.getCurrentUser.value);

const greetingMessage = computed(() => {
  const hours = new Date().getHours();
  let translationKey;
  if (hours < 12) {
    translationKey = 'ONBOARDING.GREETING_MORNING';
  } else if (hours < 18) {
    translationKey = 'ONBOARDING.GREETING_AFTERNOON';
  } else {
    translationKey = 'ONBOARDING.GREETING_EVENING';
  }
  return t(translationKey, {
    name: currentUser.value.name,
    installationName: globalConfig.value.installationName,
  });
});
</script>

<template>
  <div
    class="grid w-full max-w-4xl min-h-screen gap-4 p-8 mx-auto overflow-auto lg:max-w-5xl grid-cols-1 md:grid-cols-3 auto-rows-min font-inter"
  >
    <div class="col-span-full">
      <p
        class="text-xl font-semibold text-n-slate-12 font-interDisplay tracking-[0.3px]"
      >
        {{ greetingMessage }}
      </p>
      <p class="max-w-2xl text-base text-n-slate-11">
        {{
          $t('ONBOARDING.DESCRIPTION', {
            installationName: globalConfig.installationName,
          })
        }}
      </p>
    </div>
    <OnboardingFeatureCard
      class="md:col-span-2"
      to="settings_inbox_new"
      :title="$t('ONBOARDING.ALL_CONVERSATION.TITLE')"
      :description="$t('ONBOARDING.ALL_CONVERSATION.DESCRIPTION')"
      :link-text="$t('ONBOARDING.ALL_CONVERSATION.NEW_LINK')"
    >
      <template #scene>
        <ChannelFlowScene />
      </template>
    </OnboardingFeatureCard>
    <OnboardingFeatureCard
      to="settings_teams_new"
      :title="$t('ONBOARDING.TEAM_MEMBERS.TITLE')"
      :description="$t('ONBOARDING.TEAM_MEMBERS.DESCRIPTION')"
      :link-text="$t('ONBOARDING.TEAM_MEMBERS.NEW_LINK')"
    >
      <template #scene>
        <TeamScene />
      </template>
    </OnboardingFeatureCard>
    <OnboardingFeatureCard
      to="canned_list"
      :title="$t('ONBOARDING.CANNED_RESPONSES.TITLE')"
      :description="$t('ONBOARDING.CANNED_RESPONSES.DESCRIPTION')"
      :link-text="$t('ONBOARDING.CANNED_RESPONSES.NEW_LINK')"
    >
      <template #scene>
        <CannedResponseScene />
      </template>
    </OnboardingFeatureCard>
    <OnboardingFeatureCard
      class="md:col-span-2"
      to="labels_list"
      :title="$t('ONBOARDING.LABELS.TITLE')"
      :description="$t('ONBOARDING.LABELS.DESCRIPTION')"
      :link-text="$t('ONBOARDING.LABELS.NEW_LINK')"
    >
      <template #scene>
        <LabelsScene />
      </template>
    </OnboardingFeatureCard>
  </div>
</template>
